import type { BffInput } from "@slfinrtl/ui-bff-routes"
import { getDealershipListViewRoute } from "@slfinrtl/ui-bff-routes"
import { useContext } from "react"
import { defineMessages, useIntl } from "react-intl"
import { useErrorBanner } from "src/context/errorBanner/useErrorBanner"
import { useExtractErrorMessage } from "../../../../hooks/useExtractErrorMessage/useExtractErrorMessage"
import { getAxiosInstance } from "../../common/getAxiosInstance/getAxiosInstance"
import { RequestContext } from "../../requestContext/RequestContext"

const messages = defineMessages({
	errorFetchingDealershipList: {
		defaultMessage: "An error occurred while fetching dealership list",
		id: "dealerList.errorFetchingList",
	},
})

export const useDealershipList = () => {
	const context = useContext(RequestContext)
	const errorBannerContext = useErrorBanner()
	const extractErrorMessage = useExtractErrorMessage()
	const { formatMessage } = useIntl()

	return async <RequestPathParams, RequestQueryParams, RequestBody>([input]: [
		BffInput<RequestPathParams, RequestQueryParams, RequestBody>,
	]) => {
		const axiosInstance = await getAxiosInstance(context)
		const url = getDealershipListViewRoute.buildUrl({})
		const response = await axiosInstance
			.post(url, JSON.stringify(input.body), {
				params: input.queryParams,
			})
			.catch((error: unknown) => {
				const errorMessage = extractErrorMessage(error)
				errorBannerContext.showError(
					errorMessage.message
						? errorMessage
						: { message: formatMessage(messages.errorFetchingDealershipList) },
				)
				return
			})
		return response?.data
	}
}
